import { render } from "./HeroSet1.vue?vue&type=template&id=1008aeca&scoped=true"
import script from "./HeroSet1.vue?vue&type=script&lang=js"
export * from "./HeroSet1.vue?vue&type=script&lang=js"

import "./HeroSet1.vue?vue&type=style&index=0&id=1008aeca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1008aeca"

export default script